const didBranchAddressChange = (previousAddress, currentAddress) =>
  ['street_address1', 'city', 'zip', 'state'].some(
    (addressPart) =>
      previousAddress?.[addressPart] !== currentAddress?.[addressPart]
  );

export default didBranchAddressChange;
